module.exports = __webpack_public_path__ + "static/media/hero.cf7b24b4.png";